module.exports = __webpack_public_path__ + "static/media/glide-g.8058309b.svg";